module.exports = __webpack_public_path__ + "static/khargra-e5dce75b5d1903a34771f189e7f996fc.jpeg";